import Vue from 'vue';
import modelToolsComponent from 'rrViewComponents/Model/Tools/ModelToolsComponent/sw-model-tools.vue';

export default function ($fragment) {
    $fragment.swFindWithSelf('[data-sw-model-tools]').each((el) => {
        new Vue({
            el: el,
            components: {
                'sw-model-tools': modelToolsComponent
            }
        });

    });
}
